import { Check } from "lucide-react";
import { VisuallyHiddenBankIdDialogHeaderElements } from "@/components/bank-id/components/dialog/bank-id-dialog-header-elements";
import { BankIdDialogContentHeader } from "@/components/bank-id/components/utilities/header";
import { VisuallyHiddenDialogDescription } from "@/components/bank-id/utilities/visually-hidden-dialog-description";
import { DialogContent } from "@/components/ui/dialog";
import { useTranslations } from "@/hooks/use-translations";

export function CompleteAuthentication() {
  const { __ } = useTranslations();

  return (
    <DialogContent>
      <VisuallyHiddenBankIdDialogHeaderElements />
      <VisuallyHiddenDialogDescription />

      <div className={"rounded-lg bg-green-200"}>
        <Check className={"color-green-600"} />
      </div>
      <BankIdDialogContentHeader label={__("bank_id.success.title")} />
      <span>{__("bank_id.success.description")}</span>
    </DialogContent>
  );
}
